import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/analytics";

import { initializeAuth } from "firebase/auth";
import { getReactNativePersistence } from "firebase/auth/react-native";

import AsyncStorage from "@react-native-async-storage/async-storage";

import Constants from "expo-constants";
import { MyPlanConstants } from "../../index";

const {
    apiKey,
    authDomain,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId,
} = Constants.expoConfig?.extra as MyPlanConstants;

const fireApp = firebase.initializeApp({
    apiKey,
    authDomain,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId,
});

const analytics = firebase.analytics(fireApp);

initializeAuth(fireApp, {
    persistence: getReactNativePersistence(AsyncStorage),
});

/**
 * Firestore typically barfs at objects with undefined values, e.g.
 * {
 *  foo: "bar",
 *  fu: undefined
 * }
 * This setting instructs Firestore to ignore undefined values
 * This effectively strips undefined values before saving.
 *
 * In the quiz logic, sometimes a reducer might generate an undefined value
 *
 * Some day (my prince will come) we may rewrite that logic and remove
 * this setting. But not today.
 */
firebase.firestore().settings({ ignoreUndefinedProperties: true });

/**
 * This module is a thin wrapper around Firebase
 * modules, providing the opportunity configure
 * any modules before use.
 * @module
 */

export const useFirestore = () => {
    return firebase.firestore;
};

export const useAuth = () => {
    return firebase.auth;
};

/**
 * Why is this async? Because the native version is async.
 * @param {string} screenName
 * @returns {Promise<void>}
 */
async function logScreenView(screenName: string) {
    return await Promise.resolve(analytics.setCurrentScreen(screenName));
}

export const useAnalytics = () => {
    return [analytics, logScreenView];
};

export default {
    useFirestore,
    useAuth,
    useAnalytics,
};
